import { useContext } from "react"

import { MountingPlateOrderContext } from "src/components/order/MountingPlateStore/MountingPlateOrderContext"

export function useMountingPlateOrderContext() {
  return useContext(MountingPlateOrderContext)
}
